export class DashboardModel {
  basicUserCount: number;
  driverCount: number;
  totalEarning: number;
  currencyCode: string;
  availableWalletBalance: number;
  shipmentCount: number;
  driverWithVehicleCount: number;
  ongoingShipmentCount: number;
  cancelledCount: number;
  declinedCount: number;
  completedCount: number;
  upcomingCount: number;
  sendorShipmentCount: number;
  sendorCancelledCount: number;
  sendorCompletedCount: number;
  ongoingSendorShipmentCount: number;
  basicUserShipmentCount: number;
  activeDriverCount: number;
  rideCount: number;
  unAssignedCount: number;
  ongoingRideCount: number;
}

export class DoctorDashBoardModel {
  approvalStatusCD: string;
  total: number;
  registered: number;
  pending: number;
  approved: number;
  rejected: number;
  blocked: number;
  deleted: number;
}

export class OrderDashBoardModel {
  cancelledGroupShipment: number;
  cancelledRide: number;
  cancelledShipment: number;
  completedRide: number;
  deliveredGroupShipemnt: number;
  deliveredShipemnt: number;
  onGoingGroupShipment: number;
  onGoingRide: number;
  onGoingShipment: number;
  totalGroupShipment: number;
  totalOrderCount: number;
  totalRide: number;
  totalShipment: number;
  unassignedGroupShipment: number;
  unassignedRide: number;
  unassignedShipment: number;
  upComingGroupShipment: number;
  upComingRide: number;
  upComingShipment: number;
}

export class PartnerDashBoardModel {
  totalDriver: number;
  registeredDriver: number;
  reviewInProcessDriver: number;
  approvedDriver: number;
  rejectedDriver: number;
  blockedDriver: number;
  deletedDriver: number;
  registrationInProcessDriver:number;
  expiredDriver:number;
  userStatusCD: number;
  totalDriverOnline: number;
  driverOnlineForShipment: number;
  driverOnlineForRide: number;
}

export class UserEmployeeModel {
  totalUser: number;
  approvedUser: number;
  deletedUser: number;
  blockedUser: number;
  totalEmployeee: number;
  approvedEmployee: number;
  deletedEmployee: number;
  blockedEmployee: number;
}

export class PushNotificationTemplateModel {
  eventUserId: number;
  icon: string;
  notificationBody: string;
  notificationHeader: string;
  redirectLink: string;
}
